module.exports = __webpack_public_path__ + "img/reportedIcon.660db47e.png";